export const BRAND_ASSETS = {
  icon: "/logo-icon.png",
  /** Transparent stacked lockup (shark + STATS.FAN). UI only — not OG. */
  fullLogo: "/logo-full.png",
  /** Opaque 1200×630 social card. Keep a solid background for crawlers. */
  ogImage: "/Print.png",
  ogImageAbsolute: "https://stats.fan/Print.png",
};

export const BRAND_COLORS = {
  cyan: "#84E6E5",
  navy: "#002F3F",
};

/** Transparent stacked lockup on UI surfaces (auth panel, About). */
export const brandFullLogoImgSx = {
  display: "block",
  width: "100%",
  maxWidth: 400,
  height: "auto",
  bgcolor: "transparent",
  filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.1))",
};

export const brandRgba = (hex, alpha) => {
  const n = hex.replace("#", "");
  const r = parseInt(n.slice(0, 2), 16);
  const g = parseInt(n.slice(2, 4), 16);
  const b = parseInt(n.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/** Filled public-brand CTA: teal fill, navy text for contrast. */
export const brandFilledButtonSx = {
  bgcolor: BRAND_COLORS.cyan,
  color: BRAND_COLORS.navy,
  boxShadow: `0 4px 24px ${brandRgba(BRAND_COLORS.cyan, 0.28)}`,
  "&:hover": {
    bgcolor: BRAND_COLORS.cyan,
    color: BRAND_COLORS.navy,
    filter: "brightness(1.06)",
    boxShadow: `0 6px 32px ${brandRgba(BRAND_COLORS.cyan, 0.4)}`,
  },
};

export const brandTextAccentSx = {
  color: BRAND_COLORS.cyan,
  "&:hover": { bgcolor: brandRgba(BRAND_COLORS.cyan, 0.08) },
};

/** Outlined public-brand CTA: teal border and label. */
export const brandOutlinedButtonSx = {
  color: BRAND_COLORS.cyan,
  borderColor: BRAND_COLORS.cyan,
  "&:hover": {
    borderColor: BRAND_COLORS.cyan,
    bgcolor: brandRgba(BRAND_COLORS.cyan, 0.08),
  },
};

export const BRAND_FONT_FAMILY =
  '"Varsity One BC", "Black Ops One", sans-serif';
